export default __webpack_public_path__ + "static/media/331.bade4564.png";